import { lazy } from "react";

const CommonLayout = lazy(() => import("../layouts/CommonLayout.jsx"));
const PaymentLayout = lazy(() => import("../layouts/PaymentLayout.jsx"));

const HomeView = lazy(() => import("../views/home/HomeView.jsx"));
const PaymentView = lazy(() => import("../views/payment/PaymentView.jsx"));
const PaymentCallBackView = lazy(() => import("../views/payment/PaymentCallBackView.jsx"));

const PaymentsDetailsView = lazy(() => import("../views/details/PaymentsDetailsView.jsx"));

const NoAccessErrorView = lazy(() => import("../views/error/NoAccessErrorView.jsx"));

const ThemeRoutes = [
    {
        path: "/",
        element: <PaymentLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
            { path: "/payment", exact: true, element: <PaymentView /> },
            { path: "/paymentcb", exact: true, element: <PaymentCallBackView /> },
        ],
    },
    {
        path: "/view",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <PaymentsDetailsView /> },
        ],
    },
    {
        path: "/error",
        element: <CommonLayout />,
        children: [
            { path: "/error/noaccess", exact: true, element: <NoAccessErrorView /> }
        ],
    },
]
export default ThemeRoutes;